/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useMemo, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import {
  useSalesAllIntegrationData,
  useSalesChannelData,
} from "../../../apis/integrationApis";
import {
  useProductSyncMutation,
  useProductAddMutation,
  ProductAddPayloadSchema,
} from "../../../hooks/productFetchHooks";
import { useSelector } from "react-redux";
import { usePermission } from "../../../hooks/usePermissionTabs";
import {
  IconDownload,
  IconPlus,
  IconChevronDown,
  IconChevronUp,
  IconEye,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import ListView from "../../../components/common/ListView";
import toast from "react-hot-toast";
import EntriesSelector from "../../../components/common/EntriesSelector";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import Pagination from "../../../components/common/Pagination";
import SelectInput from "../../../components/Select";
import ButtonStyled from "../../../components/common/ButtonStyled";
import AddProductFetchModal from "./AddProductFetchModal";
import {
  useProductCategoryAllListData,
  useProductSubCategoriesListData,
} from "../../../apis/productApis";
import NewCommonModal from "../../../components/common/NewCommonModal";
import ReverseToInventory from "./ReverseToInventory";
import { useLanguage } from "../../../context/LanguageContext";

interface ProductRequestModalProps {
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
}

export const RTFData = [
  {
    id: 1,
    awb: "EVZI0000000151",
    referenceId: "65465",
    client: "Sapna Industries",
    warehouse: "RiyadMain-A",
    shelfLocation: "#bay-00145",
    numberItems: 4,
    updatedBy: "Person Name",
    updatedDate: "4 Aug 2025",
    status: "Updated",
  },
  {
    id: 2,
    awb: "EVZI0000000150",
    referenceId: "SHP-002",
    client: "Sapna Industries",
    warehouse: "RiyadMain-A",
    shelfLocation: "#bay-00145",
    numberItems: 2,
    updatedBy: "Person Name",
    updatedDate: "4 Aug 2025",
    status: "Failed",
  },
  {
    id: 3,
    awb: "EVZI0000000149",
    referenceId: "SHP-003",
    client: "Sapna Industries",
    warehouse: "RiyadMain-A",
    shelfLocation: "#bay-00145",
    numberItems: 10,
    updatedBy: "Person Name",
    updatedDate: "4 Aug 2025",
    status: "Updated",
  },
  {
    id: 4,
    awb: "EVZI0000000146",
    referenceId: "SHP-004",
    client: "Sapna Industries",
    warehouse: "RiyadMain-A",
    shelfLocation: "#bay-00145",
    numberItems: 6,
    updatedBy: "Person Name",
    updatedDate: "4 Aug 2025",
    status: "Failed",
  },
];

export default function RTF({ setActiveTab }: ProductRequestModalProps) {
  const { t } = useLanguage();
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    watch,
    formState: { errors },
  } = useForm<any>();
  const { allowed: canCreateRTF } = usePermission("rtf", "create");
  const { allowed: canUpdateRTF } = usePermission("rtf", "update");
  const [isOpen, setIsOpen] = useState(false);

  const {
    register: addProductRegister,
    handleSubmit: handleAddProductSubmit,
    clearErrors: handleProductClearErrors,
    setValue: setProductValue,
    watch: productWatch,
    control,
    formState: { errors: productErrors },
  } = useForm<any>();

  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const { data: clients } = useMerchantAllListData();
  const { data: salesChannels } = useSalesAllIntegrationData();
  const { data: salesApplications } = useSalesChannelData();
  const [products, setProducts] = useState<any>();

  // Filter RTF data based on search
  const filteredRTFData = useMemo(() => {
    if (!searchFor.trim()) return RTFData;

    const searchLower = searchFor?.toLowerCase();
    return RTFData.filter((item) => {
      return (
        item?.awb?.toLowerCase()?.includes(searchLower) ||
        item?.referenceId?.toLowerCase()?.includes(searchLower) ||
        item?.client?.toLowerCase()?.includes(searchLower) ||
        item?.warehouse?.toLowerCase()?.includes(searchLower) ||
        item?.shelfLocation?.toLowerCase()?.includes(searchLower) ||
        item?.numberItems.toString().includes(searchLower) ||
        item?.updatedBy?.toLowerCase()?.includes(searchLower) ||
        item?.updatedDate?.toLowerCase()?.includes(searchLower) ||
        item?.status?.toLowerCase()?.includes(searchLower)
      );
    });
  }, [searchFor]);

  const [reverseInventory, setReverseInventory] = useState<boolean>(false);
  const openSetReverseInventoryModal = () => {
    setReverseInventory(!reverseInventory);
  };

  const [selectedOptionValues, setSelectedOptionValues] = useState<string[]>(
    [],
  );
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

  const { mutate: fetchProduct, isPending: isLoadingProductFetch } =
    useProductSyncMutation(pageNo, limit);

  const { data: allCategory } = useProductCategoryAllListData();
  const { data: subCategories } = useProductSubCategoriesListData(
    productWatch("category") || "",
  );

  const { mutate: addProduct, isPending: isAddingProduct } =
    useProductAddMutation();

  const profile = useSelector((state: any) => state.auth.profile);

  const getProductOptionValueKeys = useCallback((product: any) => {
    const keys: string[] = [];

    // Handle products with consisted products
    if (product.consisted_products && product.consisted_products.length > 0) {
      keys.push(
        ...product.consisted_products.map(
          (consisted: any) => `${product.id}-consisted-${consisted.id}`,
        ),
      );
      return keys;
    }

    // Handle simple products (no options or consisted products)
    if (!product.options || product.options.length === 0) {
      return [`${product.id}-product`];
    }

    // Handle options
    if (product.options && product.options.length > 0) {
      keys.push(
        ...product.options.flatMap((option: any) =>
          (option.values || []).map(
            (value: any) =>
              `${product.id}-option-${option.id || option.name}-value-${
                value.id || value.name
              }`,
          ),
        ),
      );
    }

    return keys;
  }, []);

  const allProductsOnPage = products?.products || [];
  const allOptionValueKeysOnPage = useMemo(
    () => allProductsOnPage.flatMap((p: any) => getProductOptionValueKeys(p)),
    [allProductsOnPage, getProductOptionValueKeys],
  );

  const selectedOnPage = useMemo(
    () =>
      selectedOptionValues.filter((id) =>
        allOptionValueKeysOnPage.includes(id),
      ),
    [selectedOptionValues, allOptionValueKeysOnPage],
  );
  const allSelected =
    allOptionValueKeysOnPage.length > 0 &&
    allOptionValueKeysOnPage.every((id: string) =>
      selectedOptionValues.includes(id),
    );
  const someSelected = selectedOnPage.length > 0 && !allSelected;

  const handleSelectAll = useCallback(
    (checked: boolean) => {
      setSelectedOptionValues((prev) => {
        if (checked) {
          const toAdd = allOptionValueKeysOnPage.filter(
            (id: any) => !prev.includes(id),
          );
          return Array.from(new Set([...prev, ...toAdd]));
        } else {
          return prev.filter((id) => !allOptionValueKeysOnPage.includes(id));
        }
      });
    },
    [allOptionValueKeysOnPage],
  );

  const handleSelectProductOptionValues = useCallback(
    (productId: string, checked: boolean) => {
      const product = allProductsOnPage.find((p: any) => p.id === productId);
      if (!product) return;

      const productOptionValueKeys = getProductOptionValueKeys(product);
      setSelectedOptionValues((prev) => {
        if (checked) {
          // For bundle products, automatically select all consisted products
          const isBundle =
            product.consisted_products && product.consisted_products.length > 0;
          const keysToAdd = isBundle
            ? product.consisted_products.map(
                (consisted: any) => `${product.id}-consisted-${consisted.id}`,
              )
            : productOptionValueKeys;
          const toAdd = keysToAdd.filter((id: any) => !prev.includes(id));
          return Array.from(new Set([...prev, ...toAdd]));
        } else {
          return prev.filter((id) => !productOptionValueKeys.includes(id));
        }
      });
    },
    [allProductsOnPage, getProductOptionValueKeys],
  );

  const handleSelectOptionValue = useCallback(
    (
      productId: string,
      optionId: string,
      valueId: string,
      checked: boolean,
    ) => {
      let key = "";
      if (optionId === "product" && valueId === "default") {
        key = `${productId}-product`;
      } else if (optionId === "consisted") {
        key = `${productId}-consisted-${valueId}`;
      } else {
        key = `${productId}-option-${optionId}-value-${valueId}`;
      }

      setSelectedOptionValues((prev) =>
        checked
          ? Array.from(new Set([...prev, key]))
          : prev.filter((id) => id !== key),
      );
    },
    [],
  );

  const toggleRow = (productId: string) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      const idNum = parseInt(productId, 10);
      if (newSet.has(idNum)) {
        newSet.delete(idNum);
      } else {
        newSet.add(idNum);
      }
      return newSet;
    });
  };

  const [columnsData, setColumnsData] = useState([
    { text: "Checkbox", value: "checkbox", isShow: true },
    { text: "S/N", value: "sn", isShow: true },
    { text: "AWB", value: "AWB", isShow: true },
    { text: "Reference ID", value: "ReferenceID", isShow: true },
    { text: "Client", value: "Client", isShow: true },
    { text: "Warehouse", value: "Warehouse", isShow: true },
    { text: "Shelf Location", value: "ShelfLocation", isShow: true },
    { text: "Number Items", value: "NumberItems", isShow: true },
    { text: "Update By", value: "updateBy", isShow: true },
    { text: "Updated Date", value: "updatedDate", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "checkbox":
          return {
            label: (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => handleSelectAll(e.target.checked)}
                  ref={(input) => {
                    if (input) {
                      input.indeterminate = someSelected;
                    }
                  }}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                                bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
            render: (c: any) => {
              const productOptionValueKeys = getProductOptionValueKeys(c);
              const selectedCount = productOptionValueKeys.filter(
                (id: string) => selectedOptionValues.includes(id),
              ).length;
              const allSelectedForProduct =
                selectedCount === productOptionValueKeys.length;
              const someSelectedForProduct =
                selectedCount > 0 && !allSelectedForProduct;

              return (
                <label className="relative flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={allSelectedForProduct}
                    onChange={(e) =>
                      handleSelectProductOptionValues(c.id, e.target.checked)
                    }
                    ref={(input) => {
                      if (input) {
                        input.indeterminate = someSelectedForProduct;
                      }
                    }}
                    className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                                bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                  />
                  <span
                    className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                  >
                    ✓
                  </span>
                </label>
              );
            },
          };
        case "sn":
          return {
            label: t("S/N"),
            render: (_: any, i: number) => (pageNo - 1) * 10 + (i + 1),
          };
        case "AWB":
          return {
            label: t("AWB"),
            render: (c: any) => c.awb,
          };
        case "ReferenceID":
          return {
            label: t("Reference ID"),
            render: (c: any) => c.referenceId,
          };
        case "Client":
          return {
            label: t("Client"),
            render: (c: any) => c.client,
          };
        case "Warehouse":
          return {
            label: t("Warehouse"),
            render: (c: any) => c.warehouse,
          };
        case "ShelfLocation":
          return {
            label: t("Shelf Location"),
            render: (c: any) => c.shelfLocation,
          };
        case "NumberItems":
          return {
            label: t("Number Items"),
            render: (c: any) => c.numberItems,
          };
        case "updateBy":
          return {
            label: t("Update By"),
            render: (c: any) => c.updatedBy,
          };

        case "updatedDate":
          return {
            label: t("Updated Date"),
            render: (c: any) => c.updatedDate,
          };
        case "status":
          return {
            label: t("Status"),
            render: (c: any) => (
              <div className="flex justify-center">
                <div className="px-4 py-1 bg-green-500 text-white text-xs font-medium rounded-full">
                  {t("Return")}
                </div>
              </div>
            ),
          };
        case "actions":
          return {
            label: t("Actions"),
            render: (c: any) => (
              <div className="flex justify-center">
                <div className="p-2 border rounded-full bg-[#F7F6F2]">
                  <IconEye size={20} />
                </div>
              </div>
            ),
          };
        default:
          return { label: "", render: () => null };
      }
    });

  const renderExpandedContent = (product: any) => {
    const idNum = parseInt(product.id, 10);
    if (!expandedRows.has(idNum)) return null;

    const hasOptions = product.options && product.options.length > 0;
    const hasConsistedProducts =
      product.consisted_products && product.consisted_products.length > 0;
    const productOptionValueKeys = getProductOptionValueKeys(product);
    const selectedCount = productOptionValueKeys.filter((id: string) =>
      selectedOptionValues.includes(id),
    ).length;
    const allSelectedForProduct =
      selectedCount === productOptionValueKeys.length;

    const getVariantSku = (optionId: string, valueId: string) => {
      if (!product.skus || product.skus.length === 0) {
        return "";
      }
      const sku = product.skus.find((s: any) =>
        s.related_option_values?.some(
          (ov: any) => String(ov) === String(valueId),
        ),
      );
      return sku?.sku || "";
    };

    return (
      <div className="bg-gray-50 p-6 border-t border-gray-200">
        <div className="space-y-6">
          {hasConsistedProducts && (
            <div className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm">
              <div className="flex items-center justify-between mb-4">
                <h5 className="font-semibold text-gray-700 text-sm uppercase tracking-wide flex items-center space-x-2">
                  <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
                  <span>{t("Products")} ({product.consisted_products.length})</span>
                </h5>
              </div>
              <div className="flex flex-wrap gap-2">
                {product.consisted_products.map((cp: any, index: number) => {
                  const cpKey = `${product.id}-consisted-${cp.id}`;
                  const isSelected = selectedOptionValues.includes(cpKey);
                  return (
                    <label
                      key={cpKey || index}
                      className={`flex items-center space-x-2 cursor-pointer p-2 rounded-lg ${
                        isSelected
                          ? "bg-indigo-50 border-indigo-200 text-indigo-700"
                          : "bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100"
                      }`}
                    >
                      <div className="flex flex-col">
                        <span className="text-xs font-medium px-2 py-1 rounded-md bg-white border border-gray-200">
                          {cp.name || "Unnamed Product"}
                        </span>
                        <span className="text-xs text-gray-500 mt-1">
                          {t("SKU")}: {cp.sku || ""}
                        </span>
                        <span className="text-xs text-gray-500 mt-1">
                          {t("Price")}: {cp.price?.amount || 0}{" "}
                          {cp.price?.currency || ""}
                        </span>
                        <span className="text-xs text-gray-500 mt-1">
                          {t("Quantity")}: {cp.quantity || 1}
                        </span>
                      </div>
                    </label>
                  );
                })}
              </div>
            </div>
          )}

          {!hasConsistedProducts && hasOptions && (
            <div className="space-y-4">
              {product.options.map((option: any, index: number) => (
                <div
                  key={option.id || index}
                  className="border border-gray-200 rounded-xl p-5 bg-white shadow-sm"
                >
                  <div className="flex items-center justify-between mb-4">
                    <h5 className="font-semibold text-gray-700 text-sm uppercase tracking-wide flex items-center space-x-2">
                      <span className="w-2 h-2 bg-indigo-500 rounded-full"></span>
                      <span>
                        {option.name} ({option.values?.length || 0})
                      </span>
                    </h5>
                    {option.values && option.values.length > 0 && (
                      <label className="flex items-center space-x-1 text-xs font-medium text-gray-600 cursor-pointer hover:text-indigo-600">
                        <input
                          type="checkbox"
                          checked={option.values.every((v: any) => {
                            const vKey = `${product.id}-option-${
                              option.id || option.name
                            }-value-${v.id || v.name}`;
                            return selectedOptionValues.includes(vKey);
                          })}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            option.values?.forEach((v: any) => {
                              handleSelectOptionValue(
                                product.id,
                                option.id || option.name,
                                v.id || v.name,
                                isChecked,
                              );
                            });
                          }}
                          className="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-indigo-500 h-4 w-4"
                        />
                        <span>{t("All")}</span>
                      </label>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {option.values && option.values.length > 0 ? (
                      option.values.map((value: any, valueIndex: number) => {
                        const vKey = `${product.id}-option-${
                          option.id || option.name
                        }-value-${value.id || value.name}`;
                        const isSelected = selectedOptionValues.includes(vKey);
                        const variantSku = getVariantSku(
                          option.id || option.name,
                          value.id || value.name,
                        );
                        return (
                          <label
                            key={vKey || valueIndex}
                            className={`flex items-center space-x-2 cursor-pointer p-2 rounded-lg ${
                              isSelected
                                ? "bg-indigo-50 border-indigo-200 text-indigo-700"
                                : "bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100"
                            }`}
                          >
                            <input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) =>
                                handleSelectOptionValue(
                                  product.id,
                                  option.id || option.name,
                                  value?.id || value?.name,
                                  e.target.checked,
                                )
                              }
                              className="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-indigo-500 h-4 w-4"
                            />
                            <div className="flex flex-col">
                              <span className="text-xs font-medium px-2 py-1 rounded-md bg-white border border-gray-200">
                                {value.name || "Unnamed Value"}
                              </span>
                              <span className="text-xs text-gray-500 mt-1">
                                {t("SKU")}: {variantSku}
                              </span>
                            </div>
                          </label>
                        );
                      })
                    ) : (
                      <div className="col-span-full text-center py-4 text-gray-400 italic text-sm">
                        {t("No values available for this option")}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {!hasConsistedProducts && !hasOptions && (
            <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 bg-white text-center shadow-sm">
              <div className="flex flex-col items-center space-y-3">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                  <span className="text-gray-400 text-sm font-medium">✓</span>
                </div>
                <label className="flex items-center justify-center space-x-3 cursor-pointer group">
                  <input
                    type="checkbox"
                    checked={selectedOptionValues.includes(
                      `${product.id}-product`,
                    )}
                    onChange={(e) =>
                      handleSelectOptionValue(
                        product.id,
                        "product",
                        "default",
                        e.target.checked,
                      )
                    }
                    className="rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-indigo-500 h-5 w-5"
                  />
                  <span className="text-sm font-semibold text-gray-700 group-hover:text-indigo-600">
                    {t("Select Entire Product (No Options or Consisted Products)")}
                  </span>
                </label>
                <p className="text-xs text-gray-500">
                  {t("SKU")}: {product.sku || ""}
                </p>
                <p className="text-xs text-gray-500">
                  {t("This product has no configurable options or consisted products.")}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const fetchProducts = (data: any) => {
    const payload = {
      clientId: data?.client,
      merchantId: data?.salesChannels,
      superUserId: profile?.superUserId,
      warehouseId: "996466bd-dff9-4ee0-af47-05947b2bed9c",
    };
    fetchProduct(payload, {
      onSuccess: (data: any) => {
        setProducts(data);
        setSelectedOptionValues([]);
        setExpandedRows(new Set<number>());
        toast.success(t("Product fetched successfully"));
        setActionModal(false);
      },
      onError: (error) => {
        toast.error(t(`${error}`));
      },
    });
  };

  const handleAddProduct = (formData: any) => {
    if (!products?.products || selectedOptionValues.length === 0) {
      console.error("No products or variants selected to add.");
      toast.error(t("Please select at least one product or variant."));
      return;
    }

    const groupedSelections: {
      [productId: string]: {
        isSimple: boolean;
        selectedOptions: { [optionId: string]: string[] };
        selectedConsistedProducts: string[];
        productData: any;
      };
    } = {};

    const selectedCategory = allCategory?.find(
      (category: any) => category?.category === formData?.category,
    );
    if (!selectedCategory) {
      console.error("Category not found");
      toast.error(t("Please select a valid category."));
      return;
    }
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);

    const currentFormData = {
      client: watch("client"),
      salesChannels: watch("salesChannels"),
      category: watch("category"),
      subCategory: watch("subCategory"),
      storageType: watch("storageType"),
      capacity: watch("capacity"),
    };

    fetchProducts(currentFormData);
  };

  return (
    <div className="grid grid-cols-12 gap-6 p-2  bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-ful rounded-r-3xl rounded-bl-3xl w-full">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <div
        className={
          reverseInventory
            ? "col-span-12 lg:col-span-7 xl:col-span-8 space-y-6"
            : "col-span-12 space-y-6"
        }
      >
        {/* Table Header Row (Connected inside the table card) */}
        <div className="px-6 py-1.5 flex flex-col md:flex-row md:items-center justify-between gap-4 select-none bg-white w-full">
          <form
            className="flex gap-2 items-center"
            onSubmit={handleSubmit(fetchProducts)}
          >
            <h1 className="text-lg text-[#212121] tracking-[-0.5px] font-semibold mr-2">
              {t("Return To Fullfilment (RTF)")}
            </h1>
          </form>

          <div className="flex items-center gap-2">
            {/* Sliding Search */}
            <div className="relative flex items-center">
              <div
                onClick={() => {
                  if (!showSearch) {
                    setShowSearch(true);
                  }
                }}
                className={`flex items-center transition-all duration-300 ease-in-out border border-slate-200 rounded-lg bg-white shadow-sm h-8 ${
                  showSearch
                    ? "w-64 px-2 cursor-default"
                    : "w-8 justify-center cursor-pointer hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95"
                }`}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSearch(!showSearch);
                  }}
                  className="flex items-center justify-center text-[#212121] focus:outline-none flex-shrink-0"
                  title={t("Search")}
                >
                  <IconSearch size={17} stroke={2.5} />
                </button>
                {showSearch && (
                  <>
                    <input
                      type="text"
                      value={searchFor}
                      onChange={(e) => {
                        setSearchFor(e.target.value);
                        setPageNo(1);
                      }}
                      placeholder={t("Search here...")}
                      autoFocus
                      className="flex-1 ml-2 bg-transparent text-xs text-[#212121] placeholder-slate-400 outline-none border-none font-medium"
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setSearchFor("");
                        setShowSearch(false);
                      }}
                      className="flex items-center justify-center p-0.5 ml-1 text-slate-400 hover:text-slate-600 focus:outline-none flex-shrink-0"
                      title={t("Clear & Close")}
                    >
                      <IconX size={14} stroke={2.5} />
                    </button>
                  </>
                )}
              </div>
            </div>

            {products && products?.totalPages * limit > 10 && (
              <EntriesSelector
                value={limit}
                options={[
                  10,
                  ...(products?.totalPages * limit > 10 ? [20] : []),
                  ...(products?.totalPages * limit > 20 ? [30] : []),
                  ...(products?.totalPages * limit > 50 ? [50] : []),
                  ...(products?.totalPages * limit > 100 ? [100] : []),
                ]}
                onChange={(val) => {
                  setLimit(val);
                  setPageNo(1);
                }}
              />
            )}

            <ColumnsFilter
              columnsData={columnsData.map(col => ({ ...col, text: t(col.text) }))}
              setHeadings={setHeadings}
            />

            <DropdownFilter
              filterheadings={[]}
              triggerClassName="border border-slate-200 bg-white rounded-lg cursor-pointer text-[#212121] hover:bg-slate-50 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150 h-8 w-8 flex items-center justify-center shadow-sm select-none"
              iconSize={17}
            />

            {/* Add to Reverse Inventory */}
            {(canCreateRTF || canUpdateRTF) && (
              <button
                onClick={openSetReverseInventoryModal}
                className={`w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-150 border shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 cursor-pointer ${
                  reverseInventory
                    ? "bg-white hover:bg-slate-50 border-slate-200 text-slate-700"
                    : "bg-[#FBD037] border-[#FBD037] text-[#131327] hover:bg-[#e2bd30]"
                }`}
                title={t("Reverse to Inventory")}
              >
                <IconPlus stroke={1.5} size={17} />
              </button>
            )}
          </div>
        </div>

        {/* Table Body Content (White bg) */}
        <div className="p-4 bg-white w-full">
          {isLoadingProductFetch ? (
            <TableSkeleton
              columns={columnsData.filter((c) => c.isShow).map((c) => t(c.text))}
              rows={6}
            />
          ) : filteredRTFData?.length ? (
            <div className="flex flex-col gap-3 w-full">
              <ListView
                data={filteredRTFData}
                columns={columns}
                renderExpandedContent={renderExpandedContent}
                expandedRows={expandedRows}
                mainDivClassName="bg-white border border-gray-200/80 rounded-[20px] shadow-sm overflow-hidden"
                mailDivClassName="bg-white rounded-[20px]"
                trClassName="hover:bg-[#FBD037]/5 group transition-colors duration-150"
              />

              <div className="flex justify-center items-center pt-4">
                {products?.totalPages > 1 && (
                  <Pagination
                    currentPage={pageNo}
                    totalPages={products?.totalPages}
                    fetchData={handlePaginationFetch}
                  />
                )}
              </div>
            </div>
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>

      {/* Right Column: ReverseToInventory Sidebar Card (Outside the table card) */}
      {reverseInventory && (
        <div className="col-span-12 xl:col-span-4 space-y-4  mt-2 xl:static fixed inset-y-0 right-0 z-[35] w-full sm:w-[450px] xl:w-auto p-4 pt-[76px] sm:pt-[96px] xl:p-0 shadow-2xl xl:shadow-none bg-white xl:bg-transparent overflow-y-auto xl:overflow-visible flex flex-col justify-start">
          <div className="flex items-center justify-between border-b border-[#ECECEC] pb-2">
            <h2 className="text-base font-bold text-[#212121]">
              {t("Reverse to Inventory")}
            </h2>
            <button
              onClick={openSetReverseInventoryModal}
              className="p-1 rounded-full hover:bg-slate-100 text-slate-500 transition flex items-center justify-center"
              title={t("Close")}
            >
              <IconX size={16} />
            </button>
          </div>
          <ReverseToInventory
            register={register}
            errors={errors}
            clearErrors={clearErrors}
            setValue={setValue}
            control={control}
            watch={watch}
          />
        </div>
      )}

      {isOpen && (
        <AddProductFetchModal
          open={isOpen}
          onClose={() => setIsOpen(false)}
          setValue={setProductValue}
          watch={productWatch}
          register={addProductRegister}
          errors={productErrors}
          clearErrors={handleProductClearErrors}
          categories={allCategory}
          subCategories={subCategories}
          products={selectedOptionValues}
          handleSubmit={handleAddProductSubmit(handleAddProduct)}
          isPending={isAddingProduct}
        />
      )}
    </div>
  );
}
